import { ChildProps } from '@apollo/client/react/hoc';
// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import MarketplacePageWrapper from '../../marketplace/marketplace_page_wrapper';
import SaleIneligibleView from './sale_ineligible_view';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import constants from '../../shared/constants';
import { Location } from 'history';
import {
  core_apimessages_CollectionHeader_CollectionType,
  Core_Sale_HeaderQuery,
  Core_Sale_HeaderQueryVariables,
} from '@reverbdotcom/commons/src/gql/graphql';
import { collectionInfoFragment } from '../../marketplace/collection_header_display';
import CMSCenteredPageHead from '@reverbdotcom/commons/src/cms/headers/cms_centered_page_head';
import { SaleInformation } from './sale_information';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

const REASONS = constants.SALE_BUYER_INELIGIBILITY_REASONS;
const SHOW_INVENTORY_REASONS = [REASONS.SALE_NOT_STARTED, REASONS.LOGIN_REQUIRED_SHOW_INVENTORY];

interface ExternalProps extends IUserContext {
  location: Location;
  routeParams: any;
  router: any;
}

type IProps = ChildProps<ExternalProps, Core_Sale_HeaderQuery, Core_Sale_HeaderQueryVariables>;

export class SaleGrid extends React.Component<IProps, {}> {
  shouldHideSale() {
    if (this.props.user.isAdmin) { return false; }

    const reason = this.props.data?.collectionHeader?.sale?.buyerIneligibilityReason;

    // sometimes we still want to show inventory when a user's not eligible
    return reason && SHOW_INVENTORY_REASONS.indexOf(reason) < 0;
  }

  renderHeader() {
    const collectionHeader = this.props.data?.collectionHeader;
    if (!collectionHeader) return null;

    return (
      <CMSCenteredPageHead
        title={collectionHeader.title}
        subtitle={collectionHeader.description}
        imageUrl={collectionHeader.fullBleedImage?.source}
        actionUrl={this.props.location.pathname}
        searchPlaceholder={I18n.t('discovery.saleInformation.searchPrompt')}
        fineprint={
          <SaleInformation
            sale={collectionHeader?.sale}
            description={collectionHeader.description}
            location={this.props.location}
          />
        }
      />
    );
  }

  renderContents() {
    if (this.shouldHideSale()) {
      return <SaleIneligibleView sale={this.props.data?.collectionHeader?.sale} saleSlug={this.props.routeParams.sale_slug} />;
    }

    return (
      <MarketplacePageWrapper pageName={MParticlePageName.Sale} />
    );
  }

  render() {
    return (
      <div>
        {this.renderHeader()}
        {this.renderContents()}
      </div>
    );
  }
}

const headerQuery = gql`
  query Core_Sale_Header(
    $collectionType: core_apimessages_CollectionHeader_CollectionType
    $collectionSlug: String
  ) {
    collectionHeader(input: {
      collectionType: $collectionType
      collectionSlug: $collectionSlug
    }) {
      _id
      ... CollectionInfo
      sale {
        id
        buyerIneligibilityReason
        state
        percent
        discountValue
        code
        shopName
        shopSlug
        saleType
        startsAt {
          seconds
        }
        endsAt {
          seconds
        }
      }
    }
  }
  ${collectionInfoFragment}
`;

const connect = withGraphql<
IProps,
Core_Sale_HeaderQuery,
Core_Sale_HeaderQueryVariables
>(headerQuery, {
  options: (ownProps) => {
    return {
      ssr: false, // used to render components below the fold (not important for SEO or initial page rendering)
      variables: {
        collectionType: core_apimessages_CollectionHeader_CollectionType.CuratedSet,
        collectionSlug: ownProps.routeParams.sale_slug,
      },
    };
  },
});

export default withUserContext(connect(SaleGrid));
